<template>
    <div>
        <rkm-table
            :items="data.model.tipos"
            :fields="fields.datatables.tipo"
        >
            <template v-slot:cell(actions)="{ index }">
                <rkm-button
                    @click="$refs.Modal.open(index)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    components: { Modal },
    computed: {
        fields() {

            return {
                datatables: {
                    tipo: [
                        { key: 'unidade.nomeFantasia', label: 'Unidade', sortable: true },
                        { key: 'unidade.infraestrutura.nome', label: 'Local de atendimento', sortable: true },
                        { key: 'tipo.nome', label: 'Tipo', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        }
    },
    methods: {
        handleDestroy(index) {

            const destroy = async () => this.data.model.tipos.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir a parametrização?', destroy)
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>